<template>
  <!-- <div :class="{ 'has-logo': showLogo }" :style="{ backgroundColor: bgColor }">
    <el-menu :default-active="activeMenu" :background-color="bgColor" :text-color="textColor" :unique-opened="true"
      active-text-color="#0D83FC" mode="horizontal" :ellipsis="false">
      <sidebar-item v-for="(r, index) in sidebarRouters" :key="r.path + index" :item="r" :base-path="r.path" />
    </el-menu>
  </div> -->
  <div :class="{ 'has-logo': showLogo }" :style="{ backgroundColor: bgColor }" class="horizontal-menu-container" ref="containerRef">
    <el-menu :default-active="activeMenu" :background-color="bgColor" :text-color="textColor"
      :unique-opened="true" active-text-color="#0D83FC" mode="horizontal" :ellipsis="false">
      <sidebar-item v-for="(r, index) in sidebarRouters" :key="r.path + index" :item="r" :base-path="r.path" />
    </el-menu>
    
    <div class="sliding-indicator" :style="indicatorStyle"></div>
  </div>
</template>

<script setup lang="ts">
import SidebarItem from './SidebarItemHor.vue';
import useAppStore from '@/store/modules/app';
import useSettingsStore from '@/store/modules/settings';
import usePermissionStore from '@/store/modules/permission';
import { RouteRecordRaw } from 'vue-router';

const { proxy } = getCurrentInstance() as ComponentInternalInstance;

const route = useRoute();
const appStore = useAppStore();
const settingsStore = useSettingsStore();
const permissionStore = usePermissionStore();
const sidebarRouters = computed<RouteRecordRaw[]>(() => permissionStore.getSidebarRoutes());
console.log("sidebarRouters:", sidebarRouters);
const showLogo = computed(() => settingsStore.sidebarLogo);

const activeMenu = computed(() => {
  const { meta, path } = route;
  // if set path, the sidebar will highlight the path you set
  if (meta.activeMenu) {
    return meta.activeMenu;
  }
  return path;
});
const containerRef = ref<HTMLElement | null>(null);
const indicatorStyle = ref({
  transform: 'translateX(0px)',
  opacity: 0,
});

// 计算目标元素位置并移动指示线
const moveIndicator = (targetEl: HTMLElement) => {
  if (!targetEl || !containerRef.value) return;
  const containerRect = containerRef.value.getBoundingClientRect();
  const targetRect = targetEl.getBoundingClientRect();

  // 计算目标元素中心点相对于容器的左偏移 (保持你原有的 40px 宽度居中设计)
  const centerOffset = (targetRect.left - containerRect.left) + (targetRect.width / 2);
  
  indicatorStyle.value = {
    transform: `translateX(${centerOffset - 20}px)`, // 减去 20px (即 40px 宽度的一半) 实现居中
    opacity: 1,
  };
};

// 重置指示线回当前激活的菜单项
const resetToActive = () => {
  nextTick(() => {
    if (!containerRef.value) return;
    // 优先寻找顶级独立菜单项
    let activeEl = containerRef.value.querySelector('.el-menu-item.is-active') as HTMLElement;
    // 如果没有，说明激活的是带有子菜单的项
    if (!activeEl) {
      activeEl = containerRef.value.querySelector('.el-sub-menu.is-active > .el-sub-menu__title') as HTMLElement;
    }
    
    if (activeEl) {
      moveIndicator(activeEl);
    } else {
      indicatorStyle.value.opacity = 0; // 没找到则隐藏
    }
  });
};

const handleMouseOver = (e: MouseEvent) => {
  // 仅监听顶级菜单项的悬浮 (el-menu-item 或 sub-menu 的标题)
  const target = (e.target as HTMLElement).closest('.el-menu > .el-menu-item, .el-menu > .el-sub-menu > .el-sub-menu__title') as HTMLElement;
  if (target) {
    moveIndicator(target);
  }
};

const handleMouseLeave = () => {
  resetToActive(); // 鼠标移开整个菜单容器，回到激活项
};

onMounted(() => {
  if (containerRef.value) {
    containerRef.value.addEventListener('mouseover', handleMouseOver);
    containerRef.value.addEventListener('mouseleave', handleMouseLeave);
  }
  // 延迟初始化，等待 Element Plus 内部 DOM 渲染完毕
  setTimeout(resetToActive, 100); 
});

onBeforeUnmount(() => {
  if (containerRef.value) {
    containerRef.value.removeEventListener('mouseover', handleMouseOver);
    containerRef.value.removeEventListener('mouseleave', handleMouseLeave);
  }
});

// 监听路由高亮变化，实时移动线条
watch(activeMenu, () => {
  resetToActive();
});
const bgColor = "#131519"
const textColor = "#C1C3C4"
</script>

<style lang="scss" scoped>
/* 确保父容器是相对定位 */
.horizontal-menu-container {
  position: relative;
}

/* 独立抽离的滑动指示线样式 */
.sliding-indicator {
  position: absolute;
  bottom: 0px; /* 贴合你原本 calc(100% - 5px) 的高度 */
  height: 2px;
  width: 40px; /* 固定的 40px 宽度 */
  background: #0D83FC;
  border-radius: 5px;
  /* 增加贝塞尔曲线，让滑动有一种“回弹”的高级感 */
  transition: transform 0.35s cubic-bezier(0.25, 1.2, 0.6, 1.1);
  pointer-events: none; /* 穿透点击事件，防止阻挡菜单触发 */
  z-index: 10;
}

.hamburger-container {
  line-height: 46px;
  height: 100%;
  float: left;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
</style>